import { isMobileViewport } from '@/hooks/use-mobile';
import { canExploreSignupDashboard } from '../signup/activation';

const STORAGE_KEY = 'showNewLayout';

/** A phone in either orientation (its short side is under the md breakpoint). */
export const isPhoneDevice = () =>
	typeof window !== 'undefined' &&
	window.matchMedia('(pointer: coarse)').matches &&
	Math.min(window.screen.width, window.screen.height) < 768;

// Decided once per page load, so rotating a phone or resizing a window never
// swaps the whole layout (and the page's state) out from under someone.
let forcedForThisLoad: boolean | undefined;
const forcedByScreen = () => {
	if (forcedForThisLoad === undefined) forcedForThisLoad = isPhoneDevice() || isMobileViewport();
	return forcedForThisLoad;
};

const storedPreference = () => {
	try {
		return localStorage.getItem(STORAGE_KEY);
	} catch {
		return null;
	}
};

/**
 * Whether the dashboard uses the sidebar layout. Phones always do: only that
 * layout has the tab bar and phone screens. The saved switch still applies on
 * larger screens and is never overwritten here.
 */
export function getShowNewLayout(auth?: Parameters<typeof canExploreSignupDashboard>[0]) {
	return storedPreference() === 'true' || canExploreSignupDashboard(auth) || forcedByScreen();
}

/** The layout switch is pointless where the new layout is forced. */
export const canSwitchLayout = () => !forcedByScreen();
